import React from 'react';
import { generateUnrestrictedInternalTransferTableColumns } from './generateUnrestrictedInternalTransferTableColumns';
import { Grid, Header2Text } from '../../../../../../ui-toolkit';
import { IInternalTransferData } from '../../../../../../types/order/escrow/IInternalTransferData';
import { StyledDisbursedContainer } from '../../../shared/StyledDisbursedContainer';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { useHasFeatureFlag } from '../../../../../../selectors/useHasFeatureFlag';

interface IUnrestrictedInternalTransferContainerProps {
  internalTransfers: IInternalTransferData[];
}

export const UnrestrictedInternalTransfersContainer: React.FC<IUnrestrictedInternalTransferContainerProps> = ({
  internalTransfers,
}) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const unrestrictedInternalTransferColumns: IBootstrapTableColumnProps<any>[] =
    generateUnrestrictedInternalTransferTableColumns(isZillowClosingEnabled);
  return (
    <Grid>
      <Header2Text>Unrestricted Internal Transfers</Header2Text>
      <StyledDisbursedContainer
        defaultSorted={[{ dataField: 'updatedAt', order: 'desc' }]}
        columns={unrestrictedInternalTransferColumns}
        keyField={'id'}
        data={internalTransfers}
      />
    </Grid>
  );
};
